import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20minimalist%20fashion%20scene%20with%20carefully%20curated%20sneakers%20and%20neutral%20toned%20clothing%20items%20arranged%20on%20warm%20concrete%20floor%20with%20soft%20natural%20light%20streaming%20from%20large%20industrial%20windows%20creating%20long%20elegant%20shadows%20cream%20beige%20and%20sand%20color%20palette%20clean%20modern%20editorial%20composition%20with%20ample%20negative%20space%20on%20left%20side&width=1920&height=800&seq=cta-bg-wide-fashion-2026&orientation=landscape"
        alt="Start browsing CSSBuy spreadsheet collections today"
        title="Start Browsing CSSBuy Spreadsheet Collections Today"
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-black/55"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          <div className="lg:max-w-xl">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-5">
              Ready to Find Your<br />
              Next Great Deal?
            </h2>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md">
              Join thousands of smart shoppers already using our CSSBuy spreadsheet directory. Updated weekly with the latest verified finds across 14 categories.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Browse Spreadsheets
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <Link
              to="/cssbuy-spreadsheet-guide-2026"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-white/40 text-white font-semibold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read the Guide
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}